export enum FilterCombination {
    Or = 0,
    And = 1
}
